// extracted by mini-css-extract-plugin
export default {"wrap":"Marquee_wrap__cTvPc","track":"Marquee_track__O65UH","scroll":"Marquee_scroll__GyX1P","group":"Marquee_group__0AkzB","item":"Marquee_item__mwHkA"};